// extracted by mini-css-extract-plugin
export var emailBlockLink = "_is-0";